export enum InsightScopeKind {
	UNION = 'union',
	VEHICLE = 'vehicle',
	FLEET = 'fleet',
}
